/**
 * Mapping between board indices and dnd-kit identifiers.
 *
 * String ids are used rather than raw numbers because dnd-kit treats a falsy
 * identifier as absent, which would break cell 0.
 */

const PREFIX = 'cell-';

export function cellId(index: number): string {
  return `${PREFIX}${index}`;
}

export function cellIndex(id: string): number | null {
  if (!id.startsWith(PREFIX)) {
    return null;
  }

  const suffix = id.slice(PREFIX.length);

  // `Number('')` is 0, so an empty suffix would otherwise resolve to cell 0.
  if (!/^\d+$/.test(suffix)) {
    return null;
  }

  return Number(suffix);
}

/**
 * Resolves a dnd-kit drag end into a board drop, or `null` when the gesture
 * should be treated as a cancel.
 *
 * A missing `overId` means the pointer was released outside every cell. The
 * canvas game does the same thing via its out-of-bounds check in
 * `onBoardMouseMove`, which releases the piece without trading.
 */
export function resolveDrop(
  activeId: string,
  overId: string | null | undefined,
): { from: number; to: number } | null {
  if (!overId) {
    return null;
  }

  const from = cellIndex(activeId);
  const to = cellIndex(overId);

  if (from === null || to === null || from === to) {
    return null;
  }

  return { from, to };
}
